module.exports = __webpack_public_path__ + "img/seal.b8af2559.png";